// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.search {
    display: grid;
    grid-template-areas: "left left left . . center center center center center . .";
    grid-template-columns: repeat(12, 1fr);
    gap: 0;
    padding-bottom: var(--space-x3);
}

.search__left-container {
    grid-area: left;
    /* grid-column-start: 1;
    grid-column-end: 4;
    display: flex; */
    background: var(--white-color);
    position: fixed;
    width: 25%;
}
.search__left-container__info {
    margin: var(--space-x2-and-half) 0;
}

/* .search__right-container {
    grid-area: right;
} */
.search__right-container__title {
    margin-top: var(--space-x3);
}
.search__right-container__subtitle {
    margin-top: var(--space-x2);
}

.search__center-container {
    grid-area: center;
    margin-top: 24px;
    /* grid-column-start: 4;
    grid-column-end: 13;
    padding: var(--space-x2); */
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .search {
        display: block;
        margin: 0 12px;
    }
    .search-mobile {
        margin: 0;
    }
    .search__center-container {
        padding: 0;
    }
    
    .search__right-container {
        display: none;
    }

    .search__left-container {
        width: 100%;
        background: var(--new-background-color);
        width: calc(100% - 24px);
        z-index: 2;
    }
    .search-mobile .search__left-container {
        width: 100%;
        padding: 0 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/search/views/SearchView.styles.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,gFAAgF;IAChF,sCAAsC;IACtC,MAAM;IACN,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf;;oBAEgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,UAAU;AACd;AACA;IACI,kCAAkC;AACtC;;AAEA;;GAEG;AACH;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;;+BAE2B;AAC/B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;QACd,cAAc;IAClB;IACA;QACI,SAAS;IACb;IACA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,uCAAuC;QACvC,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,WAAW;QACX,eAAe;IACnB;AACJ","sourcesContent":["\n.search {\n    display: grid;\n    grid-template-areas: \"left left left . . center center center center center . .\";\n    grid-template-columns: repeat(12, 1fr);\n    gap: 0;\n    padding-bottom: var(--space-x3);\n}\n\n.search__left-container {\n    grid-area: left;\n    /* grid-column-start: 1;\n    grid-column-end: 4;\n    display: flex; */\n    background: var(--white-color);\n    position: fixed;\n    width: 25%;\n}\n.search__left-container__info {\n    margin: var(--space-x2-and-half) 0;\n}\n\n/* .search__right-container {\n    grid-area: right;\n} */\n.search__right-container__title {\n    margin-top: var(--space-x3);\n}\n.search__right-container__subtitle {\n    margin-top: var(--space-x2);\n}\n\n.search__center-container {\n    grid-area: center;\n    margin-top: 24px;\n    /* grid-column-start: 4;\n    grid-column-end: 13;\n    padding: var(--space-x2); */\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .search {\n        display: block;\n        margin: 0 12px;\n    }\n    .search-mobile {\n        margin: 0;\n    }\n    .search__center-container {\n        padding: 0;\n    }\n    \n    .search__right-container {\n        display: none;\n    }\n\n    .search__left-container {\n        width: 100%;\n        background: var(--new-background-color);\n        width: calc(100% - 24px);\n        z-index: 2;\n    }\n    .search-mobile .search__left-container {\n        width: 100%;\n        padding: 0 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
